import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams, withRouter, Redirect } from 'react-router-dom'
import { routes } from '../../../../constantes/routes'
import { articlesApi } from '../../../../api/articlesApi'
import { swalAlertError, swalSuccessGeneral } from '../../../../utils/swalAlert'
import { swalTitle } from '../../../../constantes/swalTitle'
import EditProductImagsAndVideo from './EditProductImagsAndVideo'
import EditProductDocuments from './EditProductDocuments'
import { onSubmitText } from '../../../../constantes/onSubmitText'
import ProductGeneralInfo from './ProductGeneralInfo'
import Header from '../../../header/Header'
import _ from 'lodash'
import '../../../../assests/styles/backoffice/editArticlesContainer.scss'
import {
  familiesActions,
  productsActions,
} from '../../../../actions/articlesActions'
import {
  familiesTypes,
  productsTypes,
} from '../../../../constantes/actionTypes'
import validators from '../../../../utils/validationsRegEx'

const EditProductsContainer = () => {
  const { id } = useParams()

  const history = useHistory()
  const userProfile = useSelector((state) => state.userProfile)
  const categories = useSelector((state) => state.categories)

  const dispatch = useDispatch()

  const editProduct = (product) =>
    dispatch(productsActions.updateProduct(product))
  const editFamily = (family) => dispatch(familiesActions.updateFamily(family))

  const [inputs, setinputs] = useState({
    id_Articulo: id,
    isArticuloFinal: '',
    referencia: '',
    nombre: '',
    descripcion: '',
    id_TipoCategoria: '',
    id_ArticuloPadre: '',
    link: '',
    businessUnits: [],
    cover: '',
    images: [],
    documents: [],
    coverCount: 0,
    imageCount: 0,
    documentCount: 0,
  })

  const [fathersArticle, setFathersArticle] = useState({
    id_Articulo: inputs.id_ArticuloPadre,
    nombre: '',
  })

  const [thereAreUnsavedFiles, setThereAreUnsavedFiles] = useState(false) // hay docuementos subidos sin guardar?

  const [isDisable, setIsDisable] = useState(true)

  const [isChangeLinkVideo, setIsChangeLinkVideo] = useState(false)

  useEffect(() => {
    if (userProfile.roles.isBackofficeVer) {
      getArticleInfoById(id)
    }
  }, [id])

  useEffect(() => {}, [isChangeLinkVideo])

  //********************** Obtener toda la info de un producto
  const getArticleInfoById = async (idArticles) => {
    try {
      const resp = await articlesApi.getInfoArticle(idArticles)

      await getAllArticlesWithSameIdCategory(resp.data.id_TipoCategoria)
      Object.keys(inputs).map((input) =>
        setinputs((inputs) => ({ ...inputs, [input]: resp.data[input] })),
      )
      // Mapear id_NegocioUnidades a businessUnits
      setinputs((prevInputs) => ({
        ...prevInputs,
        businessUnits:
          resp.data.id_NegocioUnidades || resp.data.businessUnits || [],
      }))
    } catch (error) {
      toProducts()
    }
  }

  // Para el selector y poder visaulizar todas las familias subfamlias
  const getAllArticlesWithSameIdCategory = async (id_Category) => {
    try {
      const response = await articlesApi.getAllArticleByCategoryId(id_Category)
      setFathersArticle(response.data)
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  //********************** CAMBIOS, información general del producto y imagenes (para el video)
  const handleChange = (event) => {
    const value = event.target.value
    const name = event.target.name
    if (name === 'link') {
      setIsChangeLinkVideo(true)
    }
    if (name == 'id_TipoCategoria') {
      //mostrar todos los hijos que tienen esta categoria y no es producto final
      getAllArticlesWithSameIdCategory(value)
    }
    setIsDisable(false)
    setinputs((inputs) => ({ ...inputs, [name]: value }))
  }

  //********************** Modificar datos del articulo
  const handleSubmitArticle = async () => {
    setIsDisable(true)
    try {
      // Transformar businessUnits a id_NegocioUnidades para el backend
      const { businessUnits, ...productData } = inputs
      const dataToSend = {
        ...productData,
        id_NegocioUnidades: businessUnits || [],
      }

      let response
      if (dataToSend.isArticuloFinal) response = await editProduct(dataToSend)
      else response = await editFamily(dataToSend)

      if (
        response.type === familiesTypes.UPDATE_FAMILY_SUCCESS ||
        response.type === productsTypes.UPDATE_PRODUCT_SUCCESS
      ) {
        swalSuccessGeneral(swalTitle.Actualizado, response.data)
        history.push(routes.PRODUCTS)
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
      setIsDisable(false)
    }
  }

  //**********************  FUNC AUX
  const validateForm = () => {
    return (
      validators.hasValue(inputs.nombre) &&
      validators.hasValue(inputs.id_TipoCategoria) &&
      (!inputs.isArticuloFinal ||
        (inputs.isArticuloFinal &&
          validators.hasValue(inputs.descripcion) &&
          inputs.isArticuloFinal
        )
      ) &&
      inputs.businessUnits &&
      inputs.businessUnits.length > 0
    )
  }

  const thereuploadFiles = (uploadFiles) => {
    const isEmpty = !_.isEmpty(uploadFiles)
    setThereAreUnsavedFiles(isEmpty)
  }

  const toProducts = () => {
    history.push(routes.PRODUCTS)
  }

  return (
    <>
      {userProfile.roles.isBackofficeVer ? (
        <div className='products'>
          <Header
            text={'Editar producto'}
            route={() => history.goBack()}
            backBtn={false}
          />
          <div className='filter__wrap-right mb-10'>
            <h4 className='product-title'>{inputs.nombre}</h4>
          </div>

          <div className='edit__container-info'>
            <div className='edit__container-info__general-info'>
              <ProductGeneralInfo
                inputs={inputs}
                handleChange={handleChange}
                categories={categories}
                fathersArticle={fathersArticle}
              />
              <button
                className='btn save'
                onClick={handleSubmitArticle}
                disabled={isDisable || !validateForm()}
              >
                {onSubmitText.Guardar}
              </button>
            </div>
            <div className='edit__container-info__images-video-documents'>
              <div className='edit__container-info__images-video'>
                <EditProductImagsAndVideo
                  id={id}
                  inputs={inputs}
                  handleChange={handleChange}
                  IsChangeLinkVideo={isChangeLinkVideo}
                  thereuploadFiles={thereuploadFiles}
                />
              </div>
              <div className='edit__container-info__documents'>
                <EditProductDocuments
                  id={id}
                  inputs={inputs}
                  thereuploadFiles={thereuploadFiles}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Redirect to={{ pathname: routes.MAIN }} />
      )}
    </>
  )
}

export default withRouter(EditProductsContainer)
